import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="relative rounded-2xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20reading%20scene%20with%20digital%20tablet%20displaying%20artistic%20webtoon%20illustration%2C%20soft%20ambient%20lighting%2C%20cozy%20modern%20interior%2C%20warm%20cream%20and%20beige%20tones%2C%20minimal%20aesthetic%2C%20lifestyle%20photography%20style%2C%20cinematic%20composition%2C%20relaxed%20evening%20mood%2C%20no%20text%20or%20logos&width=1440&height=600&seq=cta-bg-01&orientation=landscape"
          alt="韩漫阅读场景"
          className="w-full h-[320px] md:h-[420px] object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 via-foreground-900/40 to-transparent"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="max-w-xl px-8 md:px-14">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-5 leading-tight">
              开启你的<span className="italic font-normal text-white/70">韩漫之旅</span>
            </h2>
            <p className="text-white/70 text-sm md:text-base mb-8 leading-relaxed">
              海量高清韩漫，全类型覆盖，免费在线阅读。下拉式阅读体验，让每一话都流畅自如。
            </p>
            <Link
              to="/category/love"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即免费阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}